import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

let tmpRoutes = [];

//================================== 登录
(function () {
  tmpRoutes.push.apply(tmpRoutes, [
    {
      name: 'Login',
      path: '/login',
      component: () => import('@/views/login/Login'),
      meta: {
        title: '登录',
        requireLogin: false
      }
    },
    {
      name: 'Reg',
      path: '/reg',
      component: () => import('@/views/login/Reg'),
      meta: {
        title: '注册',
        requireLogin: false
      }
    },
    {
      path: '/sso',
      component: () => import('@/views/login/Sso'),
      meta: {
        title: 'SSO',
      }
    },
  ]);
})();

//================================== 个人中心
(function () {
  tmpRoutes.push.apply(tmpRoutes, [
    {
      path: '/me/Index',
      name: 'MeIndex',
      component: () => import('@/views/me/Index'),
      meta: {
        requireLogin: true
      }
    },
    {
      path: '/MyProfile',
      name: 'MyProfile',
      component: () => import('@/views/me/MyProfile'),
      meta: {
        requireLogin: true
      }
    },
  ]);
})();

//================================== 保险
(function () {
  tmpRoutes.push.apply(tmpRoutes, [

    /** 所有保险产品列表 **/
    {
      path: '/insurance/all_product_list',
      name: 'InsuranceAllProductList',
      component: () => import('@/views/insurance/AllProductList'),
      meta: {
        title: '保险所有产品列表',
        requireLogin: false
      }
    },
    /** 保险首页 **/
    {
      //path: '/insurance/product_list',
      path: '/',
      name: 'InsuranceIndex',
      component: () => import('@/views/insurance/Index'),
      meta: {
        title: '保险首页',
        requireLogin: false
      }
    },
    /** 保险产品详情 **/
    {
      path: '/insurance/product_view/',
      name: 'InsuranceProductView',
      component: () => import('@/views/insurance/ProductView'),
      meta: {
        title: '保险产品详情',
        requireLogin: false
      }
    },
    /** 我的保险订单列表 **/
    {
      path: '/insurance/order_list',
      name: 'InsuranceOrderList',
      component: () => import('@/views/insurance/OrderList'),
      meta: {
        title: '我的保险订单',
        requireLogin: true
      }
    },
    /** 我的理赔订单列表 **/
    {
      path: '/insurance/claimorder_list',
      name: 'InsuranceClaimOrderList',
      component: () => import('@/views/insurance/ClaimOrderList'),
      meta: {
        title: '我的理赔订单',
        requireLogin: true
      }
    },
    /** 我的保险订单详情 **/
    {
      path: '/insurance/order_view/',
      name: 'InsuranceOrderView',
      component: () => import('@/views/insurance/OrderView'),
      meta: {
        title: '我的保险订单',
        requireLogin: true
      }
    },
    /** 保单查询 **/
    {
      path: '/insurance/insurance_search/:search_type',
      name: 'InsuranceSearch',
      component: () => import('@/views/insurance/insuranceListSearch'),
      meta: {
        title: '保单查询',
        requireLogin: false
      }
    },
    /** 理赔中心 **/
    {
      path: '/insurance/claims_center/',
      name: 'InsuranceClaimsCenter',
      component: () => import('@/views/insurance/claimsCenter'),
      meta: {
        title: '保单查询',
        requireLogin: false
      }
    },
    /** 报案提交 **/
    {
      path: '/insurance/report_form/',
      name: 'InsuranceReportform',
      component: () => import('@/views/insurance/reportform'),
      meta: {
        title: '报案',
        requireLogin: false
      }
    },
    /** 赔案查询 **/
    {
      path: '/insurance/claim_search/:search_type',
      name: 'InsuranceClaimSearch',
      component: () => import('@/views/insurance/ClaimsSearch'),
      meta: {
        title: '赔案查询',
        requireLogin: false
      }
    },
    /** 理赔查询列表 **/
    {
      path: '/insurance/claim_order/',
      name: 'InsuranceClaimOrder',
      component: () => import('@/views/insurance/ClaimOrder'),
      meta: {
        title: '理赔列表',
        requireLogin: false
      }
    },
    /** 理赔文档上传 **/
    {
      path: '/insurance/claim_uploader/:id',
      name: 'InsuranceClaimsUpLoader',
      component: () => import('@/views/insurance/ClaimsUpLoader'),
      meta: {
        title: '资料上传',
        requireLogin: false
      }
    },
    // 选择车辆
    {
      path: '/choose_bike',
      name: 'ChooseBike',
      component: () => import('@/views/chooseBike/index.vue'),
      meta: {
        title: '选择车辆',
        requireLogin: true
      }
    },
    // 设置门店
    {
      path: '/store_list',
      name: 'StoreList',
      component: () => import('@/views/store/StoreList.vue'),
      meta: {
        title: '服务门店',
        requireLogin: true
      }
    },
    {
      path: '/store_promotion',
      name: 'StorePromotion',
      component: () => import('@/views/store/StorePromotion.vue'),
      meta: {
        title: '门店推广',
        requireLogin: true
      }
    },
    {
      path: '/skip_detail',
      name: 'SkipDetail',
      component: () => import('@/views/store/SkipDetail.vue'),
      meta: {
        title: '保险中台',
        requireLogin: true
      }
    },
  ]);
})();

//================================== 后台测试
(function () {
  tmpRoutes.push.apply(tmpRoutes, [
    {
      path: '/backstage',
      name: 'BackstageIndex',
      component: () => import('@/views/backstage/Index'),
    },
  ]);
})();


//================================== 兜底
(function () {
  tmpRoutes.push.apply(tmpRoutes, [
    {
      path: '*',
      redirect: '/',
    },
  ]);
})();

export default new Router({
  //mode: 'history',
  //base: '/',    
  //base: '/build/',
  routes: tmpRoutes,
})



// WEBPACK FOOTER //
// ./src/router/index.js